export default "__VITE_ASSET__ee4c7d6a__"